import { MeasureSchemaAndAnswers } from '../../components/measures/types';
import { OutstandingMeasures } from '../state';

/**
 * Maps the visitor's outstanding measures into the page shape consumed by
 * `PendingMeasuresForm`. Shared so every surface that renders pending measures
 * (the waiting-room drawer, the soft-block flow) builds identical page objects.
 *
 * Returns `undefined` when `measures` is `undefined` (i.e. still loading), so
 * callers can forward that straight through to `PendingMeasuresForm` as the
 * loading signal.
 */
export function buildMeasurePages(measures: OutstandingMeasures): MeasureSchemaAndAnswers[] | undefined {
  return measures?.map((measure) => ({
    schema: measure.schema,
    hasSubmitted: false,
    answers: {},
    errors: [],
    provider: measure.providers?.[0] ?? undefined,
  }));
}
